import React, { useState } from 'react';

const honorRoll = [
  "Asel Mankulova", "Maheen Aamir", "Wadood Abbas", "Qamar Abbas",
  "Roshaan Abdullah", "Aldiyar Abdullayev", "Kuzetayev Adilzhan", "Semyon Agapov",
  "Mrinal Agarwal", "Ahmadraza", "Muhammad Ahmed", "Aazan Ahmed",
  "Shanial Ahmed", "Afnan Ahmed", "Mukarram Ahmed", "Youssef Ahmed Hassona Ahmed",
  "Amankul Aidana", "Obehi Aikhomu", "Saiyette Aima", "Hoor Ul Ain",
  "Nabiya Ajaz", "Muhammad Usman Akbar", "Ozgur Efe Aksoy", "Absar Alam",
  "Adam Alcin", "Aleem", "Aleezay", "Muhammad Hassan Ali",
  "Syed Wajahat Ali", "Nisha Fatima Ali", "Muhammad Ali", "Jana Ali Fouad Ali",
  "Asad Ali", "Muhammad Mahad Ali", "Maheen Ali", "Rayyan Ali",
  "Amanbekova Aliya", "Naisha Almal", "Dina Alshaarani", "Ambreena",
  "Rukhma Amer", "Zara Amir", "Tayyaba Amir", "Ayesha Amir",
  "Rakymzhan Amirali", "Meerab Amjad", "Arveeda Amjad", "Arjun Ananda",
  "Hon Angel", "Muhammad Arham Anjum", "Hijab Ansar", "Wajeeha Anwar",
  "Anas Anwar", "Humna Anzaar", "Minahil Aqeel", "Amina Arfat",
  "Muhammad Taha Arif", "Kamori Evette Kyale Armstrong", "Arooj Fatima", "Muhammad Hammad Arshad",
  "Arzoo", "Andrew Asawa", "Malaika Ashfaq", "Humaira Ashraf",
  "Esha Asif", "Aiza Asif", "Umar Asim", "Mubarra Atha",
  "Abran Ather", "Maheen Atif", "Ifrah Awan", "Aylaf",
  "Marwah Azeem", "Zunaira Aziz", "Ida Babar", "Mahnoor Babar",
  "Aiman Babar", "Snehansh Bachala", "Ananya Bajpai", "Yuvan Balagurumoorthy",
  "Tara Balaji", "Abdul Basit", "Munkh-Aldar Batkhuu", "Saleha Batool",
  "Maira Batool", "Baltureyev Bekbolat", "Aariv Bhalla", "Ishita Bhanot",
  "Aayushi Bhattarai", "Abdul Sammad Azeem Ullah Rajpoot Bhatti", "Aadi Bhensdadia", "Srikar Bhuvanagiri",
  "Aleena Bilal", "Maryam Bilal", "Akshaj Bodla", "Rana Bolllineni",
  "Viren Bollu", "Suvid Bordia", "Injy Qaoud Ayoub Boulous", "Charlotte Brown",
  "Fatima Butt", "Bismah Nasir Butt", "Maya Otalora Caliman", "Sir Pharaoh Carter",
  "Sarah Castro", "Vaanya Chadha", "Tanvi Chakka", "Asmi Chakraborty",
  "Rachit Chandrakul", "Devank Chaturvedi", "Musa Haroon Chaudhary", "Asif Chaudhry",
  "Mustafa Khalid Cheema", "Abdullah Cheema", "Andy Chen", "Wanting Chen",
  "Qu Lan Cheng", "Benjamin Cheng", "Theodore Cheynel-Bertomeu", "Manith Chitragar",
  "Emily Cho", "Gaurav Chopra", "Aeden Keith Chua", "Emily Chui",
  "Sophie Voumard Cordeiro Costa", "Jacob Crainic", "Kevin Cui", "Berru Dagli",
  "Ashank Dahal", "Mithil Dalvaigari", "Ahana Das", "Zhaniya Dauletkyzy",
  "Noah Davis", "Adil Davletbaev", "Muhammad Dawood", "Arakelyan Dayana",
  "Ameen Dayisi", "Kamila Dessus", "Ashish Dhakal", "Akshara Dhawan",
  "Anirudh Dhubala", "Yugay Dmitriy", "Ramina Doszhan", "Adhrith Duddilla",
  "Nurlanuly Dulat", "Eisss", "Marwan Emad Abdelal Ali Elkholy", "Mariam Mohamed Salah Eldine Elnouby",
  "erha", "Jana Moustafa Mahmod El Said Esmail", "Zimal Faisal", "Amnah Faisal",
  "Anooj Faisal", "faiza", "Mishal Fakhr", "Mannal Farhan",
  "Malakia Farooq", "Amna Farooq", "Abdel-Aziz Gamal Farrag", "Ramtin Farzin",
  "Mahmoud Ragab Fathi", "Samin Fatima", "Tehreem Fatima", "Kanwal Fatima",
  "Alishba Fatima", "Sehar Fatima", "Fatima", "Selina Fee",
  "Alex Feng", "Fiza", "Samarth Gaggar", "Henry Gagnier",
  "Aaira Gambhir", "Chetan Gangireddy", "Mirna Ashraf Effat Azer Gendy", "Selena Ghane",
  "Tahir Ghani", "Rohma Ghazi", "Aahan Ghose", "Sameer Kamal Ghouri",
  "Zouraiz Kamran Ghumman", "Hadia Asad Gill", "Sharvin Goyal", "Aditi Goyal",
  "Ana Goyle", "Nihal Grandhi", "Aayush Grover", "Ayush Gudipati",
  "Shreyas Gudivada", "Avyay Gupta", "Arvin Gupta", "Apoorv Gupta",
  "Ridhi Gutta", "Ermina Habib", "Abeera Habib", "Hadisha Habib",
  "Hadia", "Areed Hadiya", "Ali Haider", "Syed Shayan Haider",
  "Zainab Hamid", "Malik Hammad", "Hamna", "Ryan Hao",
  "Advik Harihar", "Rana Haroon", "Fatima Hasan", "Khizar Hayat",
  "Yunran He", "Manam Hijaz", "Kha Hoang", "Hayley Hon",
  "Adrian Hsu", "Kate Huang", "Olivia Huang", "Cho Lam Huang",
  "Zill e Huma", "Shresht Hunnolli", "Muhammad Hussain", "Abdullah Hussain",
  "Muhammad Rehan Hussain", "Muhammad Huzaifa", "Zeyad Ahmed Mohamed Ibrahem", "Tehreem Iftekhar",
  "Kashfi Ijaz", "Muhammad Shaheer Imam", "Sman Imangali", "Lakshmi Greeshma Immadisetty",
  "Muhammad Ahsan Imran", "Muhammad Faizan Imran", "Kashaf Imran", "Abeera Imran",
  "Ayesha Imtiaz", "Nyle Imtiaz", "Ubaidullah Intazar", "Abeera Iqbal",
  "Zainab Irfan", "Rija Ishaq", "Mahpara Jabeen", "Michelle Jackson",
  "Vihaan Jain", "Shahzaib Javed", "Muhammad Usman Javed", "Sara Javed",
  "Noor Javed", "Syeda Wania Jawad", "Rishidharan Jayakumar", "Charlie Ji",
  "Jibek", "Sharro Jin", "Titus Bisani Johnson", "Parth Kabra",
  "Anshikaa Kaler", "Rithvik Kamesh", "Park Kamila", "Zyad Mohamed Saeed Kandel",
  "Andrew Kang", "Jungho Kang", "Arnav Kapoor", "Sambriddha Bikram Karki",
  "Advika Karthik", "Likhila Katokar", "Maryam Mohamed Salah Elden yassen Mohamed Abdelkader Khalil", "M. Mubashir Khan",
  "Hania Khan", "Rania Khan", "Nadeem Khan", "Faiza Khan",
  "Hamza Nawaz Khan", "Daim Khan", "Iyas Mahrus Khan", "Namay Khandelwal",
  "Rohan Khandelwal", "Aashna Khanna", "Maanit Khanna", "Theint Thiri Khine",
  "Abiha Khurram", "Raima Khurram", "Ayza Khurram", "Jeremy Kim",
  "Jiwan Kim", "Elisha Kim", "Kayla Kim", "Hajin Kim",
  "Sarah Kim", "Karan Kirpalani", "Zena Kishek", "Ayesha Komal",
  "Nimeesha Komatireddy", "Hitesh Konduru", "Siddharth Koneru", "Anvi Korde",
  "Attrey Koul", "Yashi Kumar", "Pranjal Kumar", "Rithvikh Kumar",
  "Ka_an Kumcu", "Kimi Kuo", "Om Kuravinakop",
  "Denis Kurylev", "Kelly Kwak", "Reyansh Lal", "Farzeen Latif",
  "Laiba Latif", "Najiha Latif", "Wesley Lau", "Jefferson Le",
  "Sofia Leder", "Kayden Lee", "Andrea Qian Lei", "Iris Lewis",
  "Allison Li", "Raymond Li", "Maxwell Li", "Simon Liang",
  "William Liang", "Kevin Lin", "Jessy Lin", "Shamir Loyal",
  "Arjun Maddi", "Maheen", "Nikhil Mahesh", "Akarsh Malavalli",
  "Meerab Malik", "Fasih Imran Malik", "Aman Malik", "Malika",
  "Tyler Malkin", "Sricharan Mallu", "Himesh K Mallula", "Manahil-Fatima",
  "Bernardo Vinicio Manfredini", "Khadija Manzoor", "Eishal Marghub", "Mariya",
  "Sathvik Maruvada", "Bourass Marya", "Zikra Maryam", "Abdul Mazeed",
  "Advita Mehta", "Fatima Mehtab", "Ayzal Mirha", "Shraavya Mishra",
  "Mostafa Mohamed", "Maya Mahmoud Mohamed Fahmy Mohamed", "Anubhav Mohapatra", "Veda Nandana Mokkapati",
  "Morgan Moloney", "Odyss Morgan", "Ayda Mortezaei", "Muhammad Mubashir",
  "Aroush Muglikar", "Isma Mujahid", "Tuba Mujeeb", "Zere Mukhanbet",
  "Muskan", "Lujain Mustafa", "Lulua Mustafa", "Nusaiba Mustarin",
  "Abdullah Naaem", "Javaria Naaz", "Sreenandhu Siju Nair", "Abhinav Nambi",
  "Syed Ayaan Naqvi", "Ishan Narkar", "Samawiyah Nasir", "Nurayim Nasiridinkyzy",
  "Marsha Nath", "Mishfa Naveed", "Kavyaa Naveen", "Abdullah Nawaz",
  "Madeeha Nayyab", "Areeba Naz", "Adwiti Neravetla", "Goh Jun Ning",
  "Areeha Noor", "Fatima Noor", "Heebba Noor", "Meeram Nouman",
  "Andrea Oraze", "Nouh Ouazil", "Ishan Pachnanda", "Rishi Pai",
  "Eashanand Palakollu", "Harshini Palakollu", "Maxim Pan", "Angela Pan",
  "Saket Shiby Parayil", "Sihyun Park", "Santosh Patapati", "Kavish Patel",
  "Prachi Gaurav Patel", "Dev Patel", "Ishita Patil", "Yogendra Nagadhar Paturi",
  "Rabia Pervez", "Shraddha Pola", "Sriram Polineni", "Daniil Prokofev",
  "Yuti Purohit", "Ansharah Qadeer", "Muhammad Qasim", "Raja Muhammad Qasim",
  "Ayesha Qayyum", "Bazil Shehwar Qureshi", "Ashutosh R", "Alisha Rafi",
  "Nimra Rafiq", "Noor Fatima Rafique", "Meer Devji Raghwani", "Kiran Raja",
  "Pratim Rajesh", "Pranav Rajesh", "Varrun Athis Rajh", "Vaishnavi Muppala Raju",
  "Mohamed Mohamed Ramadan", "Rathish Raghav Ram Kumar", "Yashika Ramreddy", "Sanskruti Swapnil Randhe",
  "Nathan Raphy", "Areeba Rashid", "Hamda Rashid", "Aliza Rashid",
  "Krishna Rastogi", "Voranitta Rattanasritapong", "Aakanksh Ravuri", "Mamoona Raza",
  "Dhithi Mahendra Reddy", "Mohamed Naleem Mohamed Reemaz", "Abdul Rehman", "Abdul Rehman",
  "Sreehari Rejimon", "Retaj", "Prathapani Revanth", "Tarannom Rezaeipour",
  "Muddasir Riaz", "Rija Rizwan", "Safa Rizwan", "Aiman Rizwan",
  "Ranziren L. Robles", "Bella Rodriguez", "Iciar Mendieta Rodriguez-Ramos", "Neel Madhav Singha Roy",
  "Muhammad Saad", "Muhammad Ayyan Sabri", "Yesmurat Sabyr", "Zainab Sadiq",
  "Tejas Saha", "Amna Sahar", "Abeera Sahar", "Trisha Sahu",
  "Muhammad Saim", "Amna Sajjad", "Iqra Sajjad", "Aqsa Sajjad",
  "Shail Sakalabhaktula", "Fiza Salma", "Zainab Salman", "Abanoub Karam Samir",
  "Azamat Samiya", "Muhammad Sammi", "Neelesh Sathish", "Nitish Sathyanarayanan",
  "Maaz Shakil Sayed", "Gabriela Segura", "Saiharitha Senthilkumar", "Kiaan Sethia",
  "Raahim Shabab", "Zainab Shafiq", "Muqaddas Shafique", "Tehreem Shahbaz",
  "Yahya Shamshad", "Neal Shandilya", "Aryan Sharma", "Ayan Shashidhar",
  "Menahil Shazaib", "Sadamah Shehnaz", "Mehar Shehreyar", "Simra Shehzadi",
  "Amna Sheraz", "Aisha Shermatova", "Sayin Shivanatri", "Mahnoor Shoukat",
  "Amit Shrestha", "Shivansh Yog Shukla", "Muhammad Huzaifa Siddiqui", "Rana Arbab Sikandar",
  "Daniyal Bin Sikandar", "Bhaumik Singh", "Deetya Singh", "Akash Kumar Singh",
  "Yatharth Singh", "Arum Sitoula", "Alexandar Slavov", "Maham Sohail",
  "Olga Veronica Benito Solano", "Shiara Sribalan", "Shrila Srinivasan", "Vedant Sriram",
  "Brianna Su", "Hanyu Su", "Abdul Subhan", "Tarun Sudhakar",
  "Sapthami Sudheer", "Sufyan", "Zainab Sufyan", "Hafiz Muhammad Sufyan",
  "Mambetaly Sultanbeibarys", "Anaya Sunthankar", "Rishaan Suresh", "Wasf-E-Ayelia Syed",
  "Bolat Syrym", "Shreyas Taduri", "Talha Tahir", "Nadeem Tahir",
  "Ayesha Zahra Tahir", "Omaima Tahir", "Haley Talati", "Avika Taneja",
  "Rick Tang", "Moiz Tanveer", "Shreyan Tarafder", "Malaika Tariq",
  "Hamza Tariq", "Tashfia Tasnim", "Iligai Taurbek", "Mekdes Aregay Tesfamariam",
  "Kavinharish Thirumurugan", "Jaimin Thummar", "Tooba", "Bermet Torobekova",
  "Mahnoor Touseef", "Danara Tungatarova", "Shirina Turayeva", "Asema Turdalieva",
  "Zimraan Uddin", "Wasi Ullah", "Umaima", "Hafsa Umar",
  "Sabina Umirzhanova", "Ummeroman", "Nevish Uppala", "Mohammad Usman",
  "Emaan Usman", "Hande Neslisah Uzun", "Anagha Venkataraman", "Kenisha Verma",
  "Tanishk Verma", "Kapish Verma", "Dhruv Vinesh", "Harshit Virdi",
  "Angelina Wang", "Smiti Wankhede", "Amna Waqas", "Hania Mubeen Warsi",
  "Hafsa Waseem", "Doha Waseem", "Ayesha Waseem", "Ryota Watanabe",
  "Shaun Ng Kai Wen", "Dominika Wierzchucka", "Raja Wijdan", "Steven Wilson",
  "Ililly Tadesse Woldemariam", "Jonathan Wu", "Emily Xue", "Zixian Yan",
  "Anthony Yang", "Manha Yasin", "Mahrukh Yasir", "Sobolev Yegor",
  "Prisha Yelamanchili", "Ayla Yessirkep", "Mikayla Young", "Sheikh Muhammad Yousaf",
  "Malaika Yousaf", "Bahar Busra Yurtdas", "Saliha Zafar", "Aman Zafar",
  "Kashaf Zahra", "zahra", "Sakina Tuz Zahra", "Fatima tuz Zahra",
  "Dua Zainab", "Syeda Maryam Zakir", "Emaan Zeeshan", "Taskeen Zehra",
  "Muhammad Zeyan", "Ingkar Zhalgas Zhadigerkyzy", "Zhomart Zhaniya", "Franklin Zhao",
  "Eric Zheng", "Zihan Zhou", "Shibo Zhu", "Syafina Layyana Zia",
  "Daniel Zou",
];

function HonorRoll2026() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = honorRoll.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 2026
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2026 Honor Roll
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7' }}>
          <strong>Congratulations to our Honor Roll recipients!</strong> These students represent the top 40% of all IRO participants.
        </p>
        <div style={{
          background: 'rgba(0, 77, 153, 0.06)',
          borderLeft: '4px solid #004d99',
          borderRadius: '8px',
          padding: '16px 20px',
          marginTop: '16px'
        }}>
          <p style={{ fontSize: '0.95rem', color: '#1a1a2e', lineHeight: '1.7', margin: 0 }}>
            Certificates for the 2026 IRO are now available — visit the Certificate page (in the top menu) and enter the email you registered with to view and download yours.
          </p>
        </div>
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {honorRoll.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Honor Roll</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 40%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default HonorRoll2026;
